// extracted by mini-css-extract-plugin
module.exports = {"brand":"ES6Zso","container":"SSqXhc","slider":"c6XQ4o6","wrapper":"fw0tta"};